exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wib-customer-service__text {\n  font-size: 36px;\n  line-height: 43px;\n}", ""]);

// exports
